module.exports = __webpack_public_path__ + "images/9d408cb898e6f68444d96249bf4e3d22-trendingImg4.png";